import { Controller } from "@hotwired/stimulus"

// A person's "Message" (contacts/_card_actions): their last conversation, in
// the same sidebar /messages opens it in (msg-detail's layout copy, via
// "jane:open-conversation") - an email thread, a chat, or a new email
// (Contacts::LatestConversation). Where that sidebar can't open (a phone, a
// page without the app shell) it falls back to the messages drawer's
// composer, as before.
export default class extends Controller {
    static values = {
        conversationUrl: String,
        conversationKey: String,
        composeUrl: String,
        title: String,
        avatar: String,
        autostart: Boolean
    }

    connect() {
        // /contacts/:id?compose=1 - the Chrome extension's Message - opens it
        // straight away, once the layout's sidebar has connected too.
        if (!this.autostartValue) return

        let url = new URL(window.location.href)
        url.searchParams.delete("compose")
        window.history.replaceState(window.history.state, "", url.toString())
        requestAnimationFrame(() => this.open())
    }

    open(event) {
        event?.preventDefault()
        let detail = { url: this.conversationUrlValue, key: this.conversationKeyValue, handled: false }
        if (detail.url) window.dispatchEvent(new CustomEvent("jane:open-conversation", { detail }))
        if (detail.handled || !this.composeUrlValue) return

        window.dispatchEvent(new CustomEvent("jane:compose", { detail: { url: this.composeUrlValue, title: this.titleValue, avatar: this.avatarValue } }))
    }
}
